import { useEffect, useState } from 'react';

/**
 * A `now` timestamp that ticks on an interval, so relative time labels stay
 * current. Mount once per panel and pass the value down - one interval for the
 * whole list rather than one per row.
 */
export default function useNow(intervalMs = 30000) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);

    return now;
}
